var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "m9.058 8 6.225-6.218A.753.753 0 1 0 14.218.717L8 6.942 1.783.717A.753.753 0 0 0 .718 1.782L6.943 8 .718 14.217a.75.75 0 0 0 0 1.065.75.75 0 0 0 1.065 0L8 9.057l6.218 6.225a.751.751 0 0 0 1.287-.532.75.75 0 0 0-.222-.533L9.058 8Z"
  })));
};
export default SvgCross;